import { render, staticRenderFns } from "./ParentInformation.vue?vue&type=template&id=24a82b07&scoped=true"
import script from "./ParentInformation.vue?vue&type=script&lang=js"
export * from "./ParentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a82b07",
  null
  
)

export default component.exports